import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginComponent } from './login/login.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { CidaasLoginComponent } from './cidaas-login/cidaas-login.component';

const routes: Routes = [
  { path: '', component: CidaasLoginComponent },
  { path: 'serial', component: LoginComponent },
  { path: 'home', component: DashboardComponent },
  { path: '**', component: DashboardComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
